import React, { useState, useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Card, Spinner, Button } from 'react-bootstrap';
import { useProvider } from './MenuProvider'; // Importa o contexto do Menu

const LojaRoute = ({ children }) => {
  const { 
    auth,
    loja,
    site,
    setLoja,
    buscarDadosPorId,
    crud,
    salvarDados,
    navigateTo,
  } = useProvider();
  const {
    get
  } = crud || {}
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);
  const { slug } = useParams();

  useEffect(()=>{
      const carregarLocal = async()=>{
        try{
          const response = await buscarDadosPorId('local_registros', "loja");
          if(response){
            setLoja(true);
          }else{
            setLoja(null);
          }
          setOk(true);
        }catch(err){
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            setOk(false);
          } 
        }finally{
          setLoading(false);
        }
      }
      const carregarPorSlug = async(slug)=>{
        try{
          const response = await get(`/gvendas/empresas/?url=${slug}&limit=1`, 'loja', false);
          if(response){
            setLoja(response[0].results[0]);
            await salvarDados('local_registros', {
              ...response[0].results[0],
              id:"loja"
            });
          }else{
            setLoja(null);
          }
          setOk(true);
        }catch(err){
          if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
            setOk(false);
          }
        }finally{
          setLoading(false);
        }
      }
      if (!!site?.empresa){
        setLoja(site?.empresa);
        setLoading(false);
        setOk(true);
        salvarDados('local_registros', {
            ...site?.empresa,
            id:"loja"
        });
      } else if (!!auth?.empresa) {
        setLoja(auth?.empresa);
        setLoading(false);
        setOk(true);
        salvarDados('local_registros', {
            ...auth?.empresa,
            id:"loja"
        });
        if(!!slug && auth?.empresa?.url !== slug) navigateTo(`/c/${auth.empresa.url}/`);
      } else if (!!slug) {
        carregarPorSlug(slug);
      } else {
        carregarLocal();
      }
  },[site, auth, slug, setLoja])
  
  if (loading) {
    return <p className="text-center"><Spinner animation="border"/></p>;
  }
  if(!(!!ok)) return;
  if (!(!!loja)) {
    return <Navigate to="/painel" />;
  }

  return children;
};

export default LojaRoute;